import { UseQueryResult, useQuery } from 'react-query'
import request from '../../../request'
import { useBuildQueryParams } from '../../../../lib/hooks/useBuildQueryParams'
import { useDealership } from '../../../../store/zustand/dealershipStore'
import { useBuildSortingParams } from '../../../../lib/hooks/useBuildSortingParams'

export type SelfServiceProduct = {
  product_item_id: string
  product_title: string
  product_condition: string
  impressions: number
  clicks: number
  conversions: number
}

type ResultType = Array<SelfServiceProduct>

export const useGetSelfServiceCampaignProducts = ({
  filters,
  pageIndex,
  pageSize,
  sorting,
}: {
  pageIndex?: number
  pageSize?: number
  filters?: Record<string, unknown>
  sorting?: Array<Record<string, unknown>>
}): UseQueryResult<DataWithPagination<ResultType>, Error> => {
  const dealership = useDealership()
  const queryParams = useBuildQueryParams(filters)
  const sortingParams = useBuildSortingParams(sorting)

  return useQuery<DataWithPagination<ResultType>, Error>(
    [
      'campaigns',
      queryParams.campaign_id,
      'reports',
      'self-service',
      'products',
      { pageIndex, pageSize, queryParams, sortingParams },
    ],
    ({ signal }) =>
      request<DataWithPagination<ResultType>>({
        url: `/agencies/${dealership?.organization_id}/dealership/${dealership?.id}/campaigns/self-service/${queryParams.campaign_id}/products`,
        method: 'GET',
        signal,
        params: {
          pageIndex: pageIndex,
          pageSize,
          ...queryParams,
          sorting: sortingParams,
        },
      }),
    {
      enabled: !!queryParams.campaign_id,
      keepPreviousData: true,
    },
  )
}
